import type { IBrushDrawConfig } from '@/version-types';
import { scaleConfig } from '../../utils/scale-config';

export const DRAW_CONFIG_BASE_WIDTH = 1242;

/** 始终从业务原始配置生成当前画布的绘制数据。 */
export function adaptDrawBrushConfig(drawConfig: IBrushDrawConfig, currentWidth: number) {
    if (drawConfig.__custom) return scaleConfig(drawConfig);
    const width = Number.isFinite(currentWidth) && currentWidth > 0 ? currentWidth : DRAW_CONFIG_BASE_WIDTH;
    return scaleConfig(drawConfig, width);
}
